import { useCallback, useMemo, useRef, useState, type ReactNode } from 'react'
import { ArticleProfileContext } from './articleProfileContext'
import { ArticleProfileDrawer, type ArticleProfileRequest } from './ArticleProfileDrawer'
import type { ArticleProfileApi } from './types'

/**
 * Провайдер профиля артикула: хранит открытый артикул и рисует единственную панель на приложение.
 * Подключается одной обёрткой вокруг страниц (AppLayout), поэтому кнопка «Профиль» работает на любой странице аналитики.
 */
export function ArticleProfileProvider({ children }: { children: ReactNode }) {
  const [request, setRequest] = useState<ArticleProfileRequest | null>(null)
  const counter = useRef(0)

  const open = useCallback<ArticleProfileApi['open']>((article, context) => {
    const value = article.trim()
    if (!value) return
    counter.current += 1
    setRequest({ id: counter.current, article: value, context })
  }, [])
  const close = useCallback(() => setRequest(null), [])
  const api = useMemo<ArticleProfileApi>(() => ({ open }), [open])

  return (
    <ArticleProfileContext.Provider value={api}>
      {children}
      {/* Ключ — номер открытия: новый артикул начинает с периода и площадки по умолчанию. */}
      <ArticleProfileDrawer key={request?.id ?? 0} request={request} onClose={close} />
    </ArticleProfileContext.Provider>
  )
}

export default ArticleProfileProvider
